import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { StyledH2, StyledH4, StyledExternalLink, theme } from '../../../theme/Global'
import { chooseNewImage } from './helpers'

export const NewsWidgetContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  box-shadow: unset;
`

export const NewsTitle = styled(StyledH2)`
  margin-bottom: 0.5rem;
}`

export const NewsCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`

export const ReadMoreLink = styled(StyledExternalLink)`
  font-size: 16px;
`

export const NewsCard = styled.a`
  color: ${theme.colors.blueText};
  text-decoration: none;
  width: 285px;
  height: 150px;
  margin: 1.5rem;
  background-image: url(${(props) => chooseNewImage(props.index)});
`

export const NewsCardText = styled(StyledH4)`
  color: ${theme.colors.text};
  text-align: left;
  padding-top: 17px;
  padding-left: 21px;
  padding-right: 21px;
`
